import React from 'react';

import { Box, FormControl, InputAdornment, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import TextField from '@components/atoms/textField';

type CourseDiscussionSearchBoxProps = {
  isInitialFetch: boolean;
  setSearchQuery: (searchQuery: string) => void;
  searchQuery: string;
  hasData: boolean;
};

const CourseDiscussionSearchBox = ({
  isInitialFetch,
  setSearchQuery,
  searchQuery,
  hasData,
}: CourseDiscussionSearchBoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation('store_course');

  const handleClear = () => {
    setSearchQuery('');
  };

  if (!hasData && isInitialFetch) {
    return null;
  }
  if (!hasData && !isInitialFetch && !searchQuery) {
    return null;
  }

  return (
    <Box sx={{ height: '40px' }} mt={2}>
      <FormControl fullWidth>
        <TextField
          sx={{
            '& .MuiInputBase-root.MuiInputBase-sizeSmall': {
              height: 40,
              fontSize: 18,
            },
          }}
          placeholder={t('course_detail.course_discussion.search_discussion')}
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ gap: 1 }}>
                {searchQuery && (
                  <Box
                    onClick={handleClear}
                    sx={{
                      cursor: 'pointer',
                      minWidth: '27px',
                      minHeight: '27px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <FontAwesomeIcon color={theme.palette.textV2.secondary} icon="fa-light fa-xmark" />
                  </Box>
                )}
                <FontAwesomeIcon color={theme.palette.primary.main} icon="fa-light fa-magnifying-glass" />
              </InputAdornment>
            ),
          }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </FormControl>
    </Box>
  );
};

export default CourseDiscussionSearchBox;
